import { render } from "./AccessibilityMagnifier.vue?vue&type=template&id=3879d23e"
import script from "./AccessibilityMagnifier.vue?vue&type=script&lang=js"
export * from "./AccessibilityMagnifier.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__